export function clearToken() {
  localStorage.removeItem("pillvery_token");
}

export function getToken() {
  try {
    const pillveryToken = localStorage.getItem("pillvery_token");
    return new Map({ pillveryToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}
